export function formatBillingEventsForFront(data) {
    return data
}

function getAllSteps(events) {
    let stepsArray = []
    events.forEach((event) => {
        if (!stepsArray.includes(event.step)) {
            stepsArray.push(event.step)
        }
    })

    return stepsArray;
}

export default {
    formatBillingEventsForFront,
    getAllSteps
}
